module.exports = __webpack_public_path__ + "img/team_as_a_service.fbb88d8b.svg";